/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Gameawards_Expandplayer2Inputs */

const id_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbesar pemutar`)
};

const ms_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembangkan pemain`)
};

const da_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udvid afspiller`)
};

const de_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Player vergrößern`)
};

const en_us2_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand player`)
};

const es_es2_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir reproductor`)
};

const es_mx2_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir reproductor`)
};

const fil_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palawakin ang player`)
};

const fr_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrandir le lecteur`)
};

const it_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espandi lettore`)
};

const hu_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lejátszó kibontása`)
};

const nl_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speler uitvouwen`)
};

const no_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utvid spiller`)
};

const pl_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozwiń odtwarzacz`)
};

const pt_br2_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir player`)
};

const pt_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir reprodutor`)
};

const ro_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extinde playerul`)
};

const fi_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laajenna soitin`)
};

const sv_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandera spelare`)
};

const vi_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở rộng trình phát`)
};

const tr_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oynatıcıyı genişlet`)
};

const cs_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozbalit přehrávač`)
};

const bg_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разширяване на плейъра`)
};

const ru_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Развернуть плеер`)
};

const uk_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розгорнути плеєр`)
};

const ar_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توسيع المشغل`)
};

const hi_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेयर बढ़ाएँ`)
};

const th_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขยายหน้าจอ`)
};

const ja_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレイヤーを拡大`)
};

const zh_cn2_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展开播放器`)
};

const zh_hant1_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展開播放器`)
};

const ko_misc_gameawards_expandplayer2 = /** @type {(inputs: Misc_Gameawards_Expandplayer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플레이어 확장`)
};

/**
* | output |
* | --- |
* | "Expand player" |
*
* @param {Misc_Gameawards_Expandplayer2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_gameawards_expandplayer2 = /** @type {((inputs?: Misc_Gameawards_Expandplayer2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Gameawards_Expandplayer2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_gameawards_expandplayer2(inputs)
	if (locale === "ms") return ms_misc_gameawards_expandplayer2(inputs)
	if (locale === "da") return da_misc_gameawards_expandplayer2(inputs)
	if (locale === "de") return de_misc_gameawards_expandplayer2(inputs)
	if (locale === "en-US") return en_us2_misc_gameawards_expandplayer2(inputs)
	if (locale === "es-ES") return es_es2_misc_gameawards_expandplayer2(inputs)
	if (locale === "es-MX") return es_mx2_misc_gameawards_expandplayer2(inputs)
	if (locale === "fil") return fil_misc_gameawards_expandplayer2(inputs)
	if (locale === "fr") return fr_misc_gameawards_expandplayer2(inputs)
	if (locale === "it") return it_misc_gameawards_expandplayer2(inputs)
	if (locale === "hu") return hu_misc_gameawards_expandplayer2(inputs)
	if (locale === "nl") return nl_misc_gameawards_expandplayer2(inputs)
	if (locale === "no") return no_misc_gameawards_expandplayer2(inputs)
	if (locale === "pl") return pl_misc_gameawards_expandplayer2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_gameawards_expandplayer2(inputs)
	if (locale === "pt") return pt_misc_gameawards_expandplayer2(inputs)
	if (locale === "ro") return ro_misc_gameawards_expandplayer2(inputs)
	if (locale === "fi") return fi_misc_gameawards_expandplayer2(inputs)
	if (locale === "sv") return sv_misc_gameawards_expandplayer2(inputs)
	if (locale === "vi") return vi_misc_gameawards_expandplayer2(inputs)
	if (locale === "tr") return tr_misc_gameawards_expandplayer2(inputs)
	if (locale === "cs") return cs_misc_gameawards_expandplayer2(inputs)
	if (locale === "bg") return bg_misc_gameawards_expandplayer2(inputs)
	if (locale === "ru") return ru_misc_gameawards_expandplayer2(inputs)
	if (locale === "uk") return uk_misc_gameawards_expandplayer2(inputs)
	if (locale === "ar") return ar_misc_gameawards_expandplayer2(inputs)
	if (locale === "hi") return hi_misc_gameawards_expandplayer2(inputs)
	if (locale === "th") return th_misc_gameawards_expandplayer2(inputs)
	if (locale === "ja") return ja_misc_gameawards_expandplayer2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_gameawards_expandplayer2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_gameawards_expandplayer2(inputs)
	return ko_misc_gameawards_expandplayer2(inputs)
});
export { misc_gameawards_expandplayer2 as "misc.gameAwards.expandPlayer" }